import React from "react";
import TaskEnginePanel from "../../tasks/TaskEnginePanel";

/* Staff tasks view — thin wrapper around the main-workspace TaskEnginePanel,
   locked to the current user's assigned tasks. Reusing the Execution UI
   gives staff the full task interaction model (click row → detail sheet,
   status transitions, approval, comments, activity log) instead of a
   simpler bespoke list. See TaskEnginePanel for `assigneeLock` semantics:
   locks filter.assignee, hides the assignee dropdown, hides the "+ New
   Task" affordance, and neutralizes the bottom-nav FAB so it can't
   accidentally open a create modal. */
export default function TasksPanel({state,dispatch,user,t,isRTL}){
  return(
    <TaskEnginePanel
      state={state}
      dispatch={dispatch}
      t={t}
      assigneeLock={user.id}
      heroTitle={isRTL?"المهام":"Tasks"}
      heroSubtitle={isRTL?"المهام المخصصة لي":"Assigned to me"}
    />
  );
}
